import React, { Component } from 'react'
import { Link} from 'react-router-dom'

import styled from 'styled-components';
const Navigation = styled.header` 
`;

class Nav extends Component {
  constructor(props){
    super(props)
    this.state = {
      isExpanded : false
    }
  }
  handleToggle(e){
    e.preventDefault()
    this.setState({
      isExpanded: !this.state.isExpanded
    })
  }
  render(){
    const  { isExpanded } = this.state   
      return(
        <Navigation>

          <div className="logo">
            <Link to="/">
              <span className="name">Movie</span><span className="gray">Hub</span>
            </Link>
          </div>

          <nav className="nav">
            <i className="fa fa-bars" aria-hidden="true" onClick={(e) => this.handleToggle(e)}>
            </i>
            <ul className={`collapsed ${isExpanded ?  'is-expanded' : '' }`}>
        
            </ul>
          </nav>

        </Navigation> 
    )
  }
}

export default Nav


// WEBPACK FOOTER //
// ./src/components/includes/Nav/Nav.js